<template>
  <div class="is-flex columns is-multiline pdt-20px">
    <div class="column is-12" v-if="isEdit">
      <app-information-msg-component :title="getTitle"
                                     :libelleList="getMessagesInfo">
      </app-information-msg-component>
    </div>
    <div class="column is-10" v-if="this.dcf.type !== typeFacture">
      <app-client-payeur :payeurs="validPayeurs"
                         :afficherLienDetail="afficherLien"
                         :intervenantsNonPayeurs="validIntervenants"
                         class="mgt-20px"/>
      <app-devis-commande :devisCommande="dcf"
                          :isEditPrevisu="isEditPrevisu"
                          :isPrevisualisation="isPrevisualisation"
                          :detailDevisCommande="detailDcf"
                          :payeurSelected="payeurSelected"
                          :afficherLien="afficherLien"
                          @masqueRemiseChange="$emit('masqueRemiseChange', $event)"
                          @masqueLigneChange="$emit('masqueLigneChange', $event)">
      </app-devis-commande>
    </div>
    <div class="column is-10" v-else>
      <facture-information :facture="detailDcf"
                           :factureDetail="dcf"
                           :isEdit="isEdit"
                           :isEditPrevisu="isEditPrevisu"
                           :isPrevisualisation="isPrevisualisation"
                           @masqueRemiseChange="$emit('masqueRemiseChange', $event)"
                           @masqueLigneChange="$emit('masqueLigneChange', $event)"/>
    </div>
    <div class="column is-2 buttons mgt-20px" v-if="isEdit">
      <a class="button is-primary"
         @click="$emit('changeIsEditPrev', !isEditPrevisu)">
        {{ isEditPrevisu ? $t('previsualisation.actions.previsualiser')
        : $t('previsualisation.actions.editPrev')}}
      </a>
      <div v-if="isEditPrevisu">
        <div class="has-text-link mgt-5px">
          {{ $t('previsualisation.textInfo') }}
        </div>
        <img src='/static/img/bodac/previsualisation/arrowPrev.svg'
             class="mgt-10px"/>
      </div>
    </div>
  </div>
</template>

<script>

import AppClientPayeur from '@/components/devisCommandes/detailDevisCommande/clientPayeur';
import AppDevisCommande from '@/components/devisCommandes/detailDevisCommande/detailEditionDevisCommande';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';
import { TYPE_COMMANDE, TYPE_FACTURE } from '@/configuration/devisConf';
import factureInformation from '@/components/factures/factureInformation';

export default {
  props: {
    detailDcf: {
      type: Object,
      required: true,
    },
    payeurSelected: {
      type: Object,
      required: true,
    },
    dcf: {
      type: Object,
      required: true,
    },
    isEditPrevisu: {
      type: Boolean,
      required: false,
      default: false,
    },
    isPrevisualisation: {
      type: Boolean,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: true,
    },
    afficherLien: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      typeFacture: TYPE_FACTURE,
    };
  },
  components: {
    AppClientPayeur,
    AppDevisCommande,
    AppInformationMsgComponent,
    factureInformation,
  },
  computed: {
    getType() {
      switch (this.dcf.type) {
        case TYPE_COMMANDE:
          return this.$i18n.t('previsualisation.info.typeDcf.commande');
        case TYPE_FACTURE:
          return this.$i18n.t('previsualisation.info.typeDcf.facture');
        default:
          return this.$i18n.t('previsualisation.info.typeDcf.devis');
      }
    },
    getTitle() {
      switch (this.dcf.type) {
        case TYPE_COMMANDE:
          return this.$i18n.t('previsualisation.info.titleInfo', { typeDcf: this.$i18n.t('previsualisation.info.typeDcf.maCommande') });
        case TYPE_FACTURE:
          return this.$i18n.t('previsualisation.info.titleInfo', { typeDcf: this.$i18n.t('previsualisation.info.typeDcf.maFacture') });
        default:
          return this.$i18n.t('previsualisation.info.titleInfo', { typeDcf: this.$i18n.t('previsualisation.info.typeDcf.monDevis') });
      }
    },
    getMessagesInfo() {
      return [{
        isLink: false,
        libelle: this.$i18n.t('previsualisation.info.textInfo', { typeDCF: this.getType }),
      }];
    },
    validPayeurs() {
      return this.detailDcf.payeurs.filter(p => p.nomCommercial);
    },
    validIntervenants() {
      return this.detailDcf.intervenants.filter(i => i.nomCommercial);
    },
  },
};
</script>
